export default {
  methods: {
    handleTableCommand(command) {
      if (command !== 'download') {
        return
      }

      this.$refs.rebuttalsTrackingTable?.downloadTable('rebuttals_table.csv')
    }
  }
}
